import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Button,
  Input,
} from 'reactstrap';
import { actionEditPractitionerManagement } from 'store/actions/practicesActions';
import { useTranslate } from 'react-translate';
import { useHistory } from 'react-router';

const PractitionerForm = () => {
  const t = useTranslate('practices');
  const dispatch = useDispatch();
  const history = useHistory();

  const { handleSubmit, register } = useForm();
  const practitioner = useSelector(state => state.practicesReducer.practitionerData);

  const [replyCheck, setReplyCheck] = useState(practitioner.patient_reply_permission);
  const [aiFeature, setAiFeature] = useState(practitioner.ai_feature_enabled);

  const onSubmit = (data) => {
    dispatch(actionEditPractitionerManagement({
      ...practitioner,
      ext_ref: data.ext_ref,
      ai_feature_enabled: aiFeature,
      patient_reply_permission: replyCheck
    }));
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Row>
        <Col md="3">
          <Label className="label">{t('th-reply-permission')}</Label>
          <FormGroup check>
            <Label check>
              <input
                className="form-control"
                type="checkbox"
                name="patient_reply_permission"
                checked={replyCheck}
                onChange={(e) => {
                  console.log("asdasds");
                  setReplyCheck(!replyCheck);
                }}
              > 
              </input>
              <span className="form-check-sign"/>
            </Label>
          </FormGroup>
        </Col>

        <Col md="3">
          <Label className="label">{t('ai-feature')}</Label>
          <FormGroup check>
            <Label check>
              <input
                className="form-control"
                type="checkbox"
                name="ai_feature_enabled"
                checked={aiFeature}
                onChange={(e) => {
                  setAiFeature(!aiFeature);
                }}
              > 
              </input>
              <span className="form-check-sign"/>
            </Label>
          </FormGroup>
        </Col>

        <Col md="3">
          <FormGroup>
            <Label for="ext_ref" className="label">{t('ext_ref')}</Label>
            <Input
              type="text"
              name="ext_ref"
              innerRef={register}
              defaultValue={practitioner.ext_ref}
            > 
            </Input>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col className="text-right">
          <Button onClick={()=> {history.goBack()}} size="sm" color="primary">
            { t('btn-cancel')}
          </Button>
          <Button type="submit" size="sm" color="info">
            { t('btn-update')}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default PractitionerForm;
